import React, { FormEvent, useContext, useEffect, useState } from "react";
import { Grid, Segment, Form, Button, Popup, Dropdown, Table, Checkbox, Input, List, Message, Modal } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import TimeSheetStore from "../../../app/stores/timesheetStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import TextareaAutosize from "react-textarea-autosize";
import { ITimeSheet } from "../../../app/models/timesheet";
import { toast } from "react-toastify";
import { RootStoreContext } from "../../../app/stores/rootStore";

const TimeSheetInputForm: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { user } = rootStore.userStore;
  const timesheetStore = useContext(TimeSheetStore);
  const {
    submitting,
    loadPayrollCycles,
    payrollcycleRegistry,
    payrunstatusByDate,
    payrollcyclesByName,
    projecttimeRegistry,
    employeeAllByName,
    loadEmployeePayrunTimeSheets,
    editEmployeeTimeSheets,
    selectPayRun,
  } = timesheetStore;

  const [employeeTime, setEmployeeTime] = useState<ITimeSheet[]>([]);
  const [selectedPayrun, setSelectedPayrun] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [requiredOnsite, setRequiredOnsite] = useState<boolean[]>(
    [false,false,false,false,false,false,false,false,false,false,false,false,false,false]);
  const [requiredOffsite, setRequiredOffsite] = useState<boolean[]>(
    [false,false,false,false,false,false,false,false,false,false,false,false,false,false]);
  const [timeCheck, setTimeCheck] = useState<boolean[]>(
    [false,false,false,false,false,false,false,false,false,false,false,false,false,false]);

  if (timesheetStore.loadingInitial)
    return <LoadingComponent content="Loading time sheet..." />;

  // const handleSubmit = () => {
  //   editEmployeeTimeSheets(employeeTime);
  // };

  const employeeOptions = employeeAllByName.map(function (emp) {
    var option = { "key": emp.id, "text": emp.name, "value": emp.email }
    return option;
  }
  );
  
  const payrunstatusOptions = payrollcyclesByName.slice(Math.max(payrollcyclesByName.length - 5, 0)).map(function (pay) {
    var option = { "key": pay.payRun, 
                  "text": <div> <strong>{pay.payRun}</strong>&nbsp;&nbsp;({pay.endYear})</div>, 
                  "value": pay.endYear + '-' + pay.payRun }
    return option;
  }
  );

  const projecttypeOptions = Array.from(projecttimeRegistry.values()).map(function (item) {
    var option = { "key": item.code, "text": item.code, "value": item.code }
    return option;
  }
  );

  function getDayOfWeek(date: string) {
    const dayOfWeek = new Date(date).getDay();    
    return isNaN(dayOfWeek) ? null : 
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
  }

  const fulldayOptions = [{ key: 'Full Day', text: 'Full Day', value: '1' },
                    { key: "Half Day", text: "Half Day", value: '0.5' }];

  const lahfaOptions = [{ key: 'No LAHFA', text: 'No LAHFA', value: 'No LAHFA' },
              { key: 'LAHFA with accomodation', text: 'LAHFA with accomodation', value: 'LAHFA with accomodation'},
              { key: "LAHFA without accomodation", text: "LAHFA without accomodation", value: 'LAHFA without accomodation'}];
  
  function addDays(myDate: string, days: number) {
    return new Date(new Date(myDate).getTime() + days*24*60*60*1000).toISOString().substr(0, 10);
  }

  function convertDate(date: string) {
    var arrDate = date.split("-");
    return arrDate[2] + "/" +arrDate[1] + "/" + arrDate[0];
  } 

  function totalDays() {
    let total = 0;
    employeeTime.map((time) => {
        total = total + Number(time.fullDay);                  
    });
    return total;
  };
  
  function totalWorkingHours() {
    let total = 0;
    employeeTime.map((time) => {
        total = total + Number(time.workingHours);                  
    });
    return total;
  }; 

  function totalOvertimeHours() {
    let total = 0;
    employeeTime.map((time) => {
        total = total + Number(time.overtimeHours);                  
    });
    return total;
  }; 

  function totalWeekendHours() {
    let total = 0;
    employeeTime.map((time) => {
        total = total + Number(time.weekendHours) + Number(time.nightHours);                  
    });
    return total;
  }; 

  function hourDiff(startHour: string, endHour: string) {
    let timeStart = new Date("01/01/2007 " + startHour);
    let timeEnd = new Date("01/01/2007 " + endHour);
    let difference = timeEnd.getTime() - timeStart.getTime();
    let minutes = Math.round(difference / 60000);
    let hours = (minutes/60).toFixed(2);
    return Number(hours);
  }; 

  return (
    <Segment clearing basic>
      <Form>
        <Grid>
          <Grid.Column width='3'>
          <Dropdown 
            placeholder='Select Employee'
            options={employeeOptions} 
            selection
            search
            onChange={(e, {value}) => {setSelectedEmployee(String(value)); setEmployeeTime([])}}
            value={selectedEmployee}
          />
          </Grid.Column>
          <Grid.Column width='3'>
          <Dropdown 
            placeholder='Select Pay Run'
            options={payrunstatusOptions} 
            selection
            onChange={(e, {value}) => {setSelectedPayrun(String(value)); setEmployeeTime([])}}
            value={selectedPayrun}
          />
          </Grid.Column>
          <Grid.Column width='3'>
            <List>
              <List.Item style={{color: 'gold', fontWeight: 'bold'}}> {payrollcycleRegistry.get(selectedPayrun) &&
                 'Week 1: \xa0\xa0\xa0\xa0\xa0\xa0' + 
                 convertDate(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10)) +
                 '\xa0\xa0 - \xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 6))}
              </List.Item>
              <List.Item style={{color: 'limegreen', fontWeight: 'bold'}}>
                 {payrollcycleRegistry.get(selectedPayrun) &&
                 'Week 2: \xa0\xa0\xa0\xa0\xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 7)) +
                 '\xa0\xa0 - \xa0\xa0' + 
                 convertDate(addDays(payrollcycleRegistry.get(selectedPayrun).startDate.substr(0, 10), 13))}
              </List.Item>
            </List>
          </Grid.Column>
          <Grid.Column width='3'>
          <Button
            loading={submitting}
            floated='right'
            color='grey'
            content='Load'
            onClick={() => {
              if (selectedPayrun !== '' && selectedEmployee !== '')
                loadEmployeePayrunTimeSheets(selectedEmployee, selectedPayrun).then(
                  (time) => setEmployeeTime(time) 
                );
              else
                toast.error('Please select both employee and pay run');}}
          />
          </Grid.Column>
          
        </Grid>
        {employeeTime.map(time => {
           if (time.remark !== '')
           return (
            <Message style={{backgroundColor: 'lightyellow'}}>
            <strong>Remark for {time.attendanceDate.substr(8,2)+'/'+time.attendanceDate.substr(5,2)}</strong>: {time.remark}
           </Message>
           )
        })}
    <Table celled compact>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width='1'>Date</Table.HeaderCell>
        {/* <Table.HeaderCell width='1'  style={{paddingLeft: '0', paddingRight: '0'}}>Attend</Table.HeaderCell> */}
        <Table.HeaderCell>Project</Table.HeaderCell>
        <Table.HeaderCell width='1'>Day</Table.HeaderCell>
        <Table.HeaderCell>Site</Table.HeaderCell>
        <Table.HeaderCell>
          Onsite Time
        </Table.HeaderCell>
        <Table.HeaderCell>
          Offsite Time
        </Table.HeaderCell>
        <Table.HeaderCell width='1'>
        <p style={{margin: '0'}}>Working</p>
          <p style={{margin: '0'}}>hours</p>
        </Table.HeaderCell>
        <Table.HeaderCell width='1'>
        <p style={{margin: '0'}}>Overtime</p>
          <p style={{margin: '0'}}>hours</p>
        </Table.HeaderCell>
        <Table.HeaderCell width='1'>
        <p style={{margin: '0'}}>Night/</p>
        <p style={{margin: '0'}}>Weekend</p>
          <p style={{margin: '0'}}>hours</p>
        </Table.HeaderCell>   
        <Table.HeaderCell>LAHFA</Table.HeaderCell>   
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {employeeTime.map((time, index) => (
      <Table.Row key={time.id} active={(time.attendant === 'Y')}
      disabled={(!employeeTime[0]) || 
        ((employeeTime[0].status !== "New") && (employeeTime[0].status !== "Rejected") 
        && (employeeTime[0].status !== "Saved"))}
      >
        <Table.Cell
        style={{backgroundColor:(index < 7) ? 'yellow' : 'lightgreen'}}>
          <strong >{convertDate(time.attendanceDate)}</strong>
          <div>{getDayOfWeek(time.attendanceDate)}</div>
        </Table.Cell>
        {/* <Table.Cell style={{padding: '0'}} textAlign='center'>
          <Checkbox  
            checked={time.attendant === 'Y'}
            // onChange={(e, data) => {
            //   let newArr = [...employeeTime];
            //   (data.checked) ? newArr[index]['attendant'] = 'Y' : newArr[index]['attendant'] = 'N';
            //   setEmployeeTime(newArr);
            // }}
            disabled={(!employeeTime[0]) || 
              ((employeeTime[0].status !== "New") && (employeeTime[0].status !== "Rejected") 
              && (employeeTime[0].status !== "Saved"))}
          />
        </Table.Cell> */}
        <Table.Cell>
          <Form.Select
            onChange={(e, { name, value }) => {
              let newArr = [...employeeTime];
              newArr[index]['projectType'] = String(value);
              if (value !== '') 
              {
                newArr[index]['attendant'] = 'Y'
                if ((projecttimeRegistry.get(String(value))) && 
                (projecttimeRegistry.get(String(value)).type === 'Daily'))
                {
                  newArr[index]['fullDay'] = '1'
                }
                else
                {
                  newArr[index]['fullDay'] = '0'
                }
              }
              else 
              {
                newArr[index]['attendant'] = 'N';
                newArr[index]['fullDay'] = '0';
                newArr[index]['site'] = '';
                newArr[index]['onsiteTime'] = '';
                newArr[index]['offsiteTime'] = '';
                newArr[index]['overtimeHours'] = '0';
                newArr[index]['weekendHours'] = '0';
                newArr[index]['workingHours'] = 0;
                newArr[index]['lahfa'] = 'No LAHFA';
              }
              setEmployeeTime(newArr);
            }}
            error={(time.attendant === 'Y') && (!time.projectType) && { content: 'Please select', pointing: 'below' }}
            name="projectType"
            options={projecttypeOptions}
            value={time.projectType}
            clearable
          />
        </Table.Cell>
        <Table.Cell>
         {(projecttimeRegistry.get(time.projectType)) && 
          (projecttimeRegistry.get(time.projectType).type === 'Daily') &&
          <Form.Select
            onChange={(e, { name, value }) => {
              let newArr = [...employeeTime];
              newArr[index]['fullDay'] = String(value);
              setEmployeeTime(newArr);
            }}
            name="fullDay"
            options={fulldayOptions}
            value={String(time.fullDay)}
          />}
        </Table.Cell>
        <Table.Cell>
         {(projecttimeRegistry.get(time.projectType)) && 
          (projecttimeRegistry.get(time.projectType).type === 'Daily') &&
          <Form.Field
          control={TextareaAutosize}
          rows={1}
          onChange={(e: any) => {
            let newArr = [...employeeTime];
            newArr[index]['site'] = e.currentTarget.value;
            setEmployeeTime(newArr);
          }}
          value={time.site}
          // style={{border: 'none', padding: '0.3em 0em', minWidth: '110px'}}
        />}
        </Table.Cell>
        <Table.Cell>
        { (projecttimeRegistry.get(time.projectType)) && 
        (projecttimeRegistry.get(time.projectType).type === 'Hourly') &&
        <Form.Input
              name="onsiteTime"
              type='time'
              onChange={(e: any) => {
                let newArr = [...employeeTime];
                newArr[index]['onsiteTime'] = e.currentTarget.value;
                setEmployeeTime(newArr);
                let newRequiredOnsite = [...requiredOnsite];
                newRequiredOnsite[index] = false;
                setRequiredOnsite(newRequiredOnsite);
                let newTimeCheck = [...timeCheck];
                newTimeCheck[index] = false;
                setTimeCheck(newTimeCheck);
              }}
              value={time.onsiteTime}
              error={(requiredOnsite[index]) && 'please input onsite time'}
            />}
        </Table.Cell>
        <Table.Cell>
        { (projecttimeRegistry.get(time.projectType)) && 
        (projecttimeRegistry.get(time.projectType).type === 'Hourly') &&
           <Form.Input
              name="offsiteTime"
              type='time'
              onChange={(e: any) => {
                let newArr = [...employeeTime];
                newArr[index]['offsiteTime'] = e.currentTarget.value;
                setEmployeeTime(newArr);
                if (time.onsiteTime === '' || time.offsiteTime === '')
               {
                if (time.onsiteTime === '') 
                {
                  let newRequiredOnsite = [...requiredOnsite];
                  newRequiredOnsite[index] = true;
                  setRequiredOnsite(newRequiredOnsite);
                }
                if (time.offsiteTime === '') 
                {
                  let newRequiredOffsite = [...requiredOffsite];
                  newRequiredOffsite[index] = true;
                  setRequiredOffsite(newRequiredOffsite);
                };
               }
               else
               { 
                 if (hourDiff(time.onsiteTime, time.offsiteTime) > 0)
                 {
                  if ((hourDiff('19:00', time.onsiteTime) > 0) || (hourDiff(time.offsiteTime, '07:00') > 0))
                   {
                    let newArr = [...employeeTime];
                    newArr[index]['workingHours'] = 8;
                    setEmployeeTime(newArr);
                    let newRequiredOnsite = [...requiredOnsite];
                  newRequiredOnsite[index] = false;
                  setRequiredOnsite(newRequiredOnsite);
                  let newRequiredOffsite = [...requiredOffsite];
                  newRequiredOffsite[index] = false;
                  setRequiredOffsite(newRequiredOffsite);
                  let newTimeCheck = [...timeCheck];
                  newTimeCheck[index] = false;
                  setTimeCheck(newTimeCheck);
                   }
                  else if (getDayOfWeek(time.attendanceDate) === 'Saturday')
                  {
                    if ((hourDiff(time.offsiteTime, '13:00') >= 0))
                    {
                     let start = time.onsiteTime;
                     let end = time.offsiteTime;
                     let working = hourDiff(start, end);
                     let newArr = [...employeeTime];
                     newArr[index]['overtimeHours'] = String(working);
                     setEmployeeTime(newArr);
                     let newRequiredOnsite = [...requiredOnsite];
                  newRequiredOnsite[index] = false;
                  setRequiredOnsite(newRequiredOnsite);
                  let newRequiredOffsite = [...requiredOffsite];
                  newRequiredOffsite[index] = false;
                  setRequiredOffsite(newRequiredOffsite);
                  let newTimeCheck = [...timeCheck];
                  newTimeCheck[index] = false;
                  setTimeCheck(newTimeCheck);
                    }
                    else
                    {
                     let start = time.onsiteTime;
                     let end = '13:00';
                     let working = hourDiff(start, end);
                     let newArr = [...employeeTime];
                     newArr[index]['overtimeHours'] = String(working);

                     let start1 = '13:00';
                     let end1 = time.offsiteTime;
                     let working1 = hourDiff(start1, end1);
                     newArr[index]['weekendHours'] = String(working1);

                     setEmployeeTime(newArr);
                     let newRequiredOnsite = [...requiredOnsite];
                  newRequiredOnsite[index] = false;
                  setRequiredOnsite(newRequiredOnsite);
                  let newRequiredOffsite = [...requiredOffsite];
                  newRequiredOffsite[index] = false;
                  setRequiredOffsite(newRequiredOffsite);
                  let newTimeCheck = [...timeCheck];
                  newTimeCheck[index] = false;
                  setTimeCheck(newTimeCheck);
                    }
                  }
                  else if (getDayOfWeek(time.attendanceDate) === 'Sunday')
                  {
                   let start = time.onsiteTime;
                   let end = time.offsiteTime;
                   let working = hourDiff(start, end);
                   let newArr = [...employeeTime];
                   newArr[index]['weekendHours'] = String(working);
                   setEmployeeTime(newArr);
                   let newRequiredOnsite = [...requiredOnsite];
                  newRequiredOnsite[index] = false;
                  setRequiredOnsite(newRequiredOnsite);
                  let newRequiredOffsite = [...requiredOffsite];
                  newRequiredOffsite[index] = false;
                  setRequiredOffsite(newRequiredOffsite);
                  let newTimeCheck = [...timeCheck];
                  newTimeCheck[index] = false;
                  setTimeCheck(newTimeCheck);
                  }
                  else
                  {
                    let start = projecttimeRegistry.get(time.projectType).startTime;
                    let end = projecttimeRegistry.get(time.projectType).endTime;
                   //  if (hourDiff(projecttimeRegistry.get(time.projectType).startTime, time.onsiteTime) > 0) start = time.onsiteTime;
                   //  if (hourDiff(time.offsiteTime, projecttimeRegistry.get(time.projectType).endTime) > 0) end = time.offsiteTime;
                    let businessWorking = hourDiff(start, end) - (projecttimeRegistry.get(time.projectType).lunch / 60);
                    start = time.onsiteTime;
                    end = time.offsiteTime;
                    let actualWorking = hourDiff(start, end) - (projecttimeRegistry.get(time.projectType).lunch / 60);
                    let working = (businessWorking > actualWorking) ? Number(actualWorking.toFixed(2)) : Number(businessWorking.toFixed(2));
                   // let overtime = ((actualWorking - businessWorking) > 0.5) ? Number((actualWorking - businessWorking).toFixed(2)) : 0;
                    let overtime = ((actualWorking - businessWorking) > 0) ? Number((actualWorking - businessWorking).toFixed(2)) : 0;
                    let nighttime = (hourDiff('19:00', time.offsiteTime) > 0) ? hourDiff('19:00', time.offsiteTime) : 0;
                    let newArr = [...employeeTime];
                    newArr[index]['workingHours'] = working;
                    newArr[index]['overtimeHours'] = (overtime > nighttime) ? String(overtime - nighttime) : '0';
                     newArr[index]['nightHours'] = (overtime > nighttime) ? String(nighttime) : '0';
                    setEmployeeTime(newArr);
                   let newRequiredOnsite = [...requiredOnsite];
                  newRequiredOnsite[index] = false;
                  setRequiredOnsite(newRequiredOnsite);
                  let newRequiredOffsite = [...requiredOffsite];
                  newRequiredOffsite[index] = false;
                  setRequiredOffsite(newRequiredOffsite);
                  let newTimeCheck = [...timeCheck];
                  newTimeCheck[index] = false;
                  setTimeCheck(newTimeCheck);
                  }
                 }
                 else
                 {
                  let newTimeCheck = [...timeCheck];
                  newTimeCheck[index] = true;
                  setTimeCheck(newTimeCheck);
                 }
               }
              }}
              value={time.offsiteTime}
              error={(requiredOffsite[index]) && 'please input offsite time'}
            />}
            {(timeCheck[index]) && <p style={{color: 'red'}}>offsite time must be greater than onsite time</p>}
        </Table.Cell>
        <Table.Cell width='1'>
          {time.workingHours}
        </Table.Cell>
        <Table.Cell width='1'>
        { (projecttimeRegistry.get(time.projectType)) && 
        (projecttimeRegistry.get(time.projectType).type !== '') &&
        <Form.Input
              name="overtimeHours"
              onChange={(e, { name, value }) => {
                let newArr = [...employeeTime];
                newArr[index]['overtimeHours'] = value;
                setEmployeeTime(newArr);
              }}
              style={{width: '70px'}}
              value={time.overtimeHours}
            />}
        </Table.Cell>
        <Table.Cell width='1'>
        { (projecttimeRegistry.get(time.projectType)) && 
        (projecttimeRegistry.get(time.projectType).type !== '') &&
        <Form.Input
              name="weekendHours"
              onChange={(e, { name, value }) => {
                let newArr = [...employeeTime];
                (getDayOfWeek(time.attendanceDate) === 'Saturday' || 
              getDayOfWeek(time.attendanceDate) === 'Sunday') ?
                newArr[index]['weekendHours'] = value : 
                newArr[index]['nightHours'] = value;
                setEmployeeTime(newArr);
              }}
              style={{width: '70px'}}
              value={(getDayOfWeek(time.attendanceDate) === 'Saturday' || 
              getDayOfWeek(time.attendanceDate) === 'Sunday') ? time.weekendHours : time.nightHours}
            />}
        </Table.Cell> 
        <Table.Cell>
        { (projecttimeRegistry.get(time.projectType)) && 
        <Form.Select
        onChange={(e, { name, value }) => {
          let newArr = [...employeeTime];
          newArr[index]['lahfa'] = String(value);
          setEmployeeTime(newArr);
        }}
        name="lahfa"
        options={lahfaOptions}
        value={String(time.lahfa)}
      />}
        </Table.Cell>      
      </Table.Row>
    ))}
    </Table.Body>
    <Table.Footer>
        <Table.Row>
      <Table.HeaderCell>Total:
      </Table.HeaderCell>
      <Table.HeaderCell/>
      <Table.HeaderCell><strong>{totalDays()}</strong>
      </Table.HeaderCell>
      <Table.HeaderCell/>
      <Table.HeaderCell/>
      <Table.HeaderCell/>
      <Table.HeaderCell><strong>{totalWorkingHours().toFixed(2)}</strong>
      </Table.HeaderCell>
      <Table.HeaderCell><strong>{totalOvertimeHours().toFixed(2)}</strong>
      </Table.HeaderCell>
      <Table.HeaderCell><strong>{totalWeekendHours().toFixed(2)}</strong>
      </Table.HeaderCell>
      <Table.HeaderCell/>
      </Table.Row>
      </Table.Footer>
  </Table>
  </Form>
  <br/>
     <Button
          loading={submitting}
          floated='left'
          color='blue'
          content='Save'
          onClick={() => editEmployeeTimeSheets(employeeTime, 'Saved', '')}
          disabled={(!employeeTime[0]) || 
            ((employeeTime[0].status !== "New") && (employeeTime[0].status !== "Rejected") 
            && (employeeTime[0].status !== "Saved"))}
     />
     <Button
          loading={submitting}
          floated='right'
          positive
          content='Submit'
          onClick={() => editEmployeeTimeSheets(employeeTime, 'Reviewed', user!.email)}
          disabled={(!employeeTime[0]) || 
            ((employeeTime[0].status !== "New") && (employeeTime[0].status !== "Rejected") 
            && (employeeTime[0].status !== "Saved")) || (Date.now() < Date.parse(employeeTime[13].attendanceDate))}
     />
    </Segment>
  );
};

export default observer(TimeSheetInputForm);
